import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ThemeSwitcher } from "../../parts/theme-switcher/theme-switcher";
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'app-authentication.layout',
  imports: [RouterOutlet, ThemeSwitcher, RouterLink],
  templateUrl: './authentication.layout.html',
  styleUrl: './authentication.layout.scss'
})
export class AuthenticationLayout {
  constructor(public themeService: ThemeService) { }

  public get isDarkThemeActive$() {
    return this.themeService.isDarkThemeActive$;
  }


}
